import { render, staticRenderFns } from "./weapon.vue?vue&type=template&id=5fb54148&"
import script from "./weapon.vue?vue&type=script&lang=js&"
export * from "./weapon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports